import React, { useId, useRef, useState } from "react";
import { Drawer } from "antd";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import Localize from "components/service/localize";
import useStaffSummaryHelpRoles from "../hooks/use-staff-summary-help-roles";
import "./staff-summary-value.scss";
import "./staff-summary-help.scss";

const copy = (key, props = {}) => <Localize {...props}>{`STAFF_MANAGEMENT.${key}`}</Localize>;

const StaffSummaryHelp = ({ metric, attendance = false }) => {
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    const closeRef = useRef(null);
    const titleId = useId();
    const checkedIn = metric === "checkedIn";
    const titleKey = checkedIn ? "SummaryHelpCheckedInTitle" : "SummaryHelpBookedTitle";
    const roles = useStaffSummaryHelpRoles({ enabled: open && checkedIn });

    return <span className="sm-summary-help">
        <button type="button" ref={triggerRef} className="sm-summary-help-trigger"
            aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}>
            <InfoCircleOutlined aria-hidden="true" />
            <span className="sm-summary-sr-only">{copy(titleKey)}</span>
        </button>
        <Drawer placement="bottom" visible={open} onClose={() => setOpen(false)}
            className="sm-summary-help-drawer" height="auto" closable={false}
            maskClosable keyboard destroyOnClose role="dialog" aria-modal="true" aria-labelledby={titleId}
            afterVisibleChange={(visible) => {
                const target = visible ? closeRef.current : triggerRef.current;
                if (target?.isConnected) target.focus();
            }}
            title={<>
                <span id={titleId}>{copy(titleKey)}</span>
                <button type="button" ref={closeRef} className="sm-summary-help-close" onClick={() => setOpen(false)}
                    onKeyDown={(event) => {
                        // This version of Drawer handles Escape, but does not trap Tab.
                        // Close is the only focusable element in this read-only sheet.
                        if (event.key === "Tab") event.preventDefault();
                    }}>
                    <CloseOutlined aria-hidden="true" />
                    <span className="sm-summary-sr-only">{copy("SummaryHelpClose")}</span>
                </button>
            </>}>
            {checkedIn && <p className="sm-summary-help-groups" aria-live="polite">
                {roles.loading ? copy("SummaryHelpGroupsLoading") : roles.labels ?
                    copy("SummaryHelpIncludedGroups", { groups: roles.labels.join(", ") }) : copy("SummaryHelpGroupsUnavailable")}
            </p>}
            <p>{copy(checkedIn ? "SummaryHelpCheckedIn" : "SummaryHelpBooked")}</p>
            {attendance && <p>{copy(checkedIn ? "SummaryHelpCheckedInAttendance" : "SummaryHelpBookedAttendance")}</p>}
        </Drawer>
    </span>;
};

export default StaffSummaryHelp;
